export default "__VITE_ASSET__BsoLtmAC__"